/**
 * Event Tracker - 轻量级埋点 SDK
 */

import type { EventTrackerInitOptions } from './@types'
import { Collector, type Plugin } from './core/collector'

// 导入核心插件
import SessionPlugin from './plugins/session'
import CachePlugin from './plugins/cache'
import { RoutePlugin } from './plugins/route'
import { StayPlugin } from './plugins/stay'

// 注册核心插件
Collector.usePlugin(SessionPlugin, 'session')
Collector.usePlugin(CachePlugin, 'cache')
Collector.usePlugin(RoutePlugin, 'route')
Collector.usePlugin(StayPlugin, 'stay')

// 创建默认实例并直接导出（参考火山引擎设计）
const SDK = new Collector('default')

// 默认导出 SDK 实例
export default SDK

// 导出核心类（供高级用户创建多实例）
export { Collector }

// 导出类型
export type {
  EventTrackerInitOptions,
  BatchReportData,
  EventInfo,
  HeaderInfo,
  UserInfo,
} from './@types'
export type { Plugin } from './core/collector'
export type { Plugin as PluginType } from './core/collector'
